var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { AccordionSet, Accordion, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField, RecekSelection } from "./inputs";
import { PersonStatusFilterOptions } from "./PersonStatusFilterOptions";
import { PersonAuthorityLinkedFilter } from "./PersonAuthorityLinkedFilter";
import { PersonProposalOriginFilter } from "./PersonProposalOriginFilter";
export var NaturalPersonFilters = function (_a) {
    var filters = _a.filters, publishers = _a.publishers, publishersLoading = _a.publishersLoading, selectedPublisher = _a.selectedPublisher, onFilterChange = _a.onFilterChange, onStatusChange = _a.onStatusChange, onApplyFilters = _a.onApplyFilters, onPublisherInput = _a.onPublisherInput, onMyProposals = _a.onMyProposals, hasUnappliedChanges = _a.hasUnappliedChanges, canSeeSearchFailed = _a.canSeeSearchFailed, _b = _a.showProposalOriginFilter, showProposalOriginFilter = _b === void 0 ? true : _b;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.natural-person.filter.lastName",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.natural-person.filter.lastName", value: filters.lastName, onChange: function (e) {
                        return onFilterChange("lastName", e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.natural-person.filter.lastName.placeholder",
                    }), showLabel: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.natural-person.filter.firstName",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.natural-person.filter.firstName", value: filters.firstName, onChange: function (e) {
                        return onFilterChange("firstName", e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.natural-person.filter.firstName.placeholder",
                    }), showLabel: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.natural-person.filter.identifier",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.natural-person.filter.identifier", value: filters.identifier, onChange: function (e) {
                        return onFilterChange("identifier", e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.natural-person.filter.identifier.placeholder",
                    }), showLabel: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.natural-person.filter.label.status",
                }), separator: false },
                React.createElement(PersonStatusFilterOptions, { selected: filters.statuses, canSeeSearchFailed: canSeeSearchFailed, onStatusChange: onStatusChange })),
            showProposalOriginFilter && (React.createElement(PersonProposalOriginFilter, { value: filters.proposalOrigin, onChange: function (value) { return onFilterChange("proposalOrigin", value); } })),
            React.createElement(PersonAuthorityLinkedFilter, { value: filters.authorityLinked, onChange: function (value) { return onFilterChange("authorityLinked", value); } }),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.natural-person.filter.proposer",
                }), separator: false },
                onMyProposals && (React.createElement(Button, { buttonStyle: "link", marginBottom0: true, onClick: onMyProposals, type: "button" },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.filter.myProposals" }))),
                React.createElement(RecekSelection, { labelId: "ui-br-agency.natural-person.filter.proposer", showLabel: false, asyncFilter: true, value: selectedPublisher ? selectedPublisher.sourceId : "", loading: publishersLoading, onFilter: onPublisherInput, onChange: function (value) {
                        onFilterChange("proposerId", value);
                    }, dataOptions: __spreadArray(__spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-agency.collectionsList.select.option.all",
                            }),
                        }
                    ], (selectedPublisher &&
                        selectedPublisher.sourceId &&
                        selectedPublisher.name &&
                        !publishers.some(function (p) { return p.sourceId === selectedPublisher.sourceId; })
                        ? [
                            {
                                value: selectedPublisher.sourceId,
                                label: selectedPublisher.name,
                            },
                        ]
                        : []), true), publishers.map(function (p) { return ({
                        value: p.sourceId,
                        label: p.name,
                    }); }), true) }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.apply" }))));
};
